<template>
  <div class="sub-container">
    <v-card class="ml-4 mt-4" variant="flat">
      <v-card-actions>
        <span class="mt-n3 ml-4 font-weight-bold">Subscribers</span>
        <v-spacer />
        <v-btn v-if="screenSize === 'Large'" color="#38a4f8" variant="flat" class="text-none" size="small" :to="{
          name: 'importSubs',
          params: { id: routeId },
        }">
          <span class="btn-text"><v-icon class="mx-1">mdi-file-import</v-icon>Import
            subscribers</span>
        </v-btn>
        <v-btn color="#50568e" variant="flat" class="text-none" size="small" @click="redirectToAdd()">
          <span class="btn-text"><v-icon class="mx-1">mdi-account-plus</v-icon>Add Subscriber</span>
        </v-btn>
      </v-card-actions>

      <v-card-actions>
        <div class="search-field px-2">
          <p class="mt-n2 ml-3 font-weight-bold">Email</p>

          <v-text-field class="mx-2 my-2" v-model="formData.email" label="Search by Email" variant="outlined"
            density="compact" hide-details style="color: #3c3731" />
        </div>

        <v-btn color="red" variant="flat" class="text-none ml-8 mt-6" size="small" prepend-icon="mdi-magnify"
          @click="submitFilters">
          <span class="btn-text">Search</span>
        </v-btn>

        <v-btn color="teal" variant="flat" class="text-none mt-6" prepend-icon="mdi-delete-empty" size="small"
          @click="clearFilters">
          <span class="btn-text">Clear filters</span>
        </v-btn>
        <v-spacer />
        <div class="search-field">
          <v-text-field v-model="search" label="Quick Search" prepend-inner-icon="mdi-magnify" variant="outlined"
            density="compact" hide-details single-line />
        </div>
      </v-card-actions>
      <v-data-table :items="subscribersByID" :headers="headers" item-value="id" :search="search"
        :items-per-page="pagination ? pagination.page_size : 20" density="compact">
        <template #[`item.status`]="{ item }">
          <v-chip :color="getColor(item.raw.is_subscribed)" variant="flat" size="x-small">
            <span class="chip-text">{{
              item.raw.is_subscribed ? "subscribed" : "unsubscribed"
            }}</span>
          </v-chip>
        </template>

        <template #[`item.blacklist`]="{ item }">
          <v-chip v-if="item.raw.is_blacklisted" :color="getBlackColor(item.raw.is_blacklisted)" variant="flat"
            size="x-small">
            <span class="chip-text">{{
              item.raw.is_blacklisted ? "blacklisted" : ""
            }}</span>
          </v-chip>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center ga-2">
            <!-- Edit -->
            <v-tooltip location="bottom" text="Edit Subscriber">
              <template #activator="{ props }">
                <v-icon v-bind="props" class="cursor-pointer text-primary mx-3" @click="
                  $router.push({
                    name: 'AddSubscriber',
                    params: { id: item.raw.id },
                  })
                  ">
                  mdi-pencil
                </v-icon>
              </template>
            </v-tooltip>

            <!-- Subscribe / Unsubscribe -->
            <v-tooltip location="bottom" :text="item.raw.is_subscribed ? 'Unsubscribe' : 'Subscribe'">
              <template #activator="{ props }">
                <v-icon v-bind="props" class="cursor-pointer mx-3" :class="item.raw.is_subscribed ? 'text-warning' : 'text-success'
                  " @click="
                    item.raw.is_subscribed
                      ? unSubscribe(item.raw.id, item.raw.email)
                      : Subscribe(item.raw.id, item.raw.email)
                    ">
                  {{
                    item.raw.is_subscribed ? "mdi-bell-off" : "mdi-bell-plus"
                  }}
                </v-icon>
              </template>
            </v-tooltip>

            <!-- Blacklist -->
            <v-tooltip location="bottom" text="Blacklist Subscriber">
              <template #activator="{ props }">
                <v-icon v-bind="props" v-if="!item.raw.is_blacklisted" class="cursor-pointer text-deep-orange mx-3"
                  @click="Blacklist(item.raw.id, item.raw.email)">
                  mdi-account-cancel
                </v-icon>
              </template>
            </v-tooltip>

            <!-- Delete -->
            <v-tooltip location="bottom" text="Delete Subscriber">
              <template #activator="{ props }">
                <v-icon v-bind="props" class="cursor-pointer text-error mx-3"
                  @click="deleteSub(item.raw.id, item.raw.email)">
                  mdi-delete
                </v-icon>
              </template>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-card-actions class="mt-n12">
        <v-spacer class="" />
        <v-card class="mt-n3" color="#fffff" variant="flat">
          <PaginationControls :current-page="currentPage" :total-pages="pagination ? pagination.total_pages : 0"
            @page-changed="fetchSubscribers" />
        </v-card>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="loaderState" max-width="500">
      <v-card>
        <v-card-actions><v-spacer />Please Wait <v-spacer /></v-card-actions>
        <v-card-actions><v-spacer />
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>

          <v-spacer />
        </v-card-actions>

        <v-progress-linear class="mx-2 mt-n3" color="teal" indeterminate></v-progress-linear>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PaginationControls from "@/utils/PaginationControls.vue";
export default {
  name: "SubListPage",
  beforeRouteEnter(to, from, next) {
    next(() => { });
  },

  components: {
    PaginationControls,
  },
  props: {
    routeId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      selectedGroup: null,
      subStatus: null,
      menu: false,
      menu2: false,
      menu3: false,
      search: "",
      isValid: false,
      loadingState: false,
      screenSize: "",
      oldValue: false,
      buttonPress: false,
      filteredSubs: [],
      formData: {
        id: null,
        email: null,
        page: 1,
        offset: 0,
        limit: 10,
        current_page: 1,
        group_id: null,

      },

      selected: [],

      headers: [
        { title: "Created At", key: "created_at" },
        {
          title: "Name",
          key: "fullName",
          value: (item) => `${item.first_name} ${item.last_name}`,
        },
        { title: "Email", key: "email" },
        {
          title: "Status",
          key: "status",
          value: (item) => `${item.is_subscribed}`,
        },
        {
          title: "BlackList",
          key: "blacklist",
          value: (item) => `${item.is_blacklisted}`,
        },
        { title: "Group name", key: "group_name" },
        { title: "Actions", key: "actions" },
      ],
    };
  },

  computed: {
    lists() {
      return this.$store.getters["subscribers/subscribersGetters"]("Lists");
    },
    subscribersByID() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "filteredSubs"
      );
    },
    pagination() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "pagination"
      );
    },
    currentPage() {
      return this.pagination ? this.pagination.page : 1;
    },
    pageSize() {
      return this.pagination ? this.pagination.page_size : 10;
    },
    // filteredSubs() {
    //   return this.$store.getters["subscribers/subscribersGetters"](
    //     "filteredSubs"
    //   );
    // },
    loaderState() {
      return this.$store.getters["subscribers/subscribersGetters"](
        "loaderState"
      );
    },
    checkFilter() {
      return (this.subStatus !== null && this.buttonPress) ||
        (this.selectedGroup !== null && this.buttonPress)
        ? true
        : false;
    },
  },

  mounted() {
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
    const data = { id: parseInt(this.$route.params.id) };
    this.$store.dispatch("subscribers/getSubscribersByID", data);
  },
  methods: {
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";
    },

    deleteSub(val, val2) {
      if (confirm(`Are you sure you want to delete subscriber: ${val2}`)) {
        this.$store.dispatch("subscribers/deleteSubscriber", parseInt(val));
      }
    },

    unSubscribe(val, val2) {
      if (confirm(`Are you sure you want to unsubscribe subscriber: ${val2}`)) {
        const data = {
          subdata: {
            is_subscribed: false,
          },
          id: parseInt(val),
        };
        this.$store.dispatch("subscribers/unsubSubscriber", data);
      }
    },

    Subscribe(val, val2) {
      if (confirm(`Are you sure you want to resubscribe subscriber: ${val2}`)) {
        const data = {
          subdata: {
            is_subscribed: true,
          },
          id: parseInt(val),
        };
        this.$store.dispatch("subscribers/unsubSubscriber", data);
      }
    },

    Blacklist(val, val2) {
      if (confirm(`Are you sure you want to blacklist subscriber: ${val2}`)) {
        const data = {
          subdata: {
            is_blacklisted: true,
          },
          id: parseInt(val),
        };
        this.$store.dispatch("subscribers/unsubSubscriber", data);
      }
    },

    getColor(val) {
      if (val) return "#46c35f";
      else return "orange";
    },
    getBlackColor(val) {
      if (val) return "black";
      else return "";
    },
    changeAvatarColor(item) {
      // Change the color of the clicked avatar
      item.avatarProps.color = "red"; // Change to desired color
    },
    redirectToAdd() {
      this.$router.push({ name: "AddSubscriber" });
    },

    submitFilters() {
      this.formData = {
        id: parseInt(this.$route.params.id),
        email: this.formData.email,
      };
      this.$store.dispatch("subscribers/getSubscribersByID", this.formData);
    },

    clearFilters() {
      this.formData = {
        id: parseInt(this.$route.params.id),
        email: null,
      };
      this.$store.dispatch("subscribers/getSubscribersByID", this.formData);
    },
    onPaginationChange() {
      (this.formData.id = parseInt(this.$route.params.id)),
        (this.formData.page += 1);
      this.$store.dispatch("subscribers/getSubscribersByID", this.formData);
    },

    onPaginationNextChange() {
      if (this.formData.page <= 1) return;
      // Check if the page is greater than 1 before decrementing
      // Update the offset state
      (this.formData.id = parseInt(this.$route.params.id)),
        (this.formData.page -= 1);
      this.$store.dispatch("subscribers/getSubscribersByID", this.formData);
    },

    async fetchSubscribers(pageNumber) {
      console.log("Fetching subscribers for page:", pageNumber, this.pageSize);
      this.formData.offset = 0; // Reset offset for new page fetch

      const offset = (pageNumber - 1) * this.pageSize;

      this.formData.offset = offset; // Update the offset in formData
      this.formData.limit = this.pageSize; // Update the limit in formData
      this.formData.page = pageNumber; // Update the current page in formData
      this.formData.id = parseInt(this.$route.params.id)

      this.$store.dispatch("subscribers/getSubscribersByID", this.formData);
    },
  },

  watch: {
    loaderState: {
      handler: function (newValue, oldValue) {
        this.oldValue = oldValue;
        this.loadingState = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style>
@import url("../subscriberStyle.css");
</style>
